/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import ArgonDashboard from "./plugins/argon-dashboard";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
  if (window.caches && caches.keys) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }
}
import { API_BASE_URL, STORAGE_BASE_URL } from "./config/api";

// Third-party component styles must be loaded globally (not per-view).
// When imported inside lazy-loaded views, webpack's LimitChunkCountPlugin
// can drop these stylesheets from the extracted CSS, leaving vue-select /
// vue2-datepicker icons unstyled (rendered as huge default SVG boxes).
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue2-datepicker/index.css";

Vue.component("v-select", vSelect);

Vue.config.productionTip = false;
// Vue.config.devtools = false

if (API_BASE_URL) {
  axios.defaults.baseURL = API_BASE_URL;
}

Vue.prototype.$apiBaseUrl = API_BASE_URL;
Vue.prototype.$storageBaseUrl = STORAGE_BASE_URL;

const toBackendAbsoluteUrl = (url) => {
  if (typeof url !== "string") return url;

  if (url.startsWith("/api/") && API_BASE_URL) {
    return `${API_BASE_URL}${url}`;
  }

  if (url.startsWith("/storage/") && STORAGE_BASE_URL) {
    return `${STORAGE_BASE_URL}${url}`;
  }

  return url;
};

// In production, frontend and backend may be on different domains.
const originalOpen = window.open.bind(window);
window.open = (url, ...args) => originalOpen(toBackendAbsoluteUrl(url), ...args);

document.addEventListener(
  "click",
  (event) => {
    const anchor =
      event.target && event.target.closest
        ? event.target.closest("a[href]")
        : null;

    if (!anchor) return;

    const currentHref = anchor.getAttribute("href");
    const mappedHref = toBackendAbsoluteUrl(currentHref);

    if (mappedHref !== currentHref) {
      anchor.setAttribute("href", mappedHref);
    }
  },
  true
);

Vue.use(ArgonDashboard);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
